export const TaskLabel = {
  Tasksheet: "Tasksheet",
  Timesheet: "TimeSheet",
  ProjectName: "Project Name",
  TaskName: "Task Name",
  TaskDetail: "Task Details",
  DeveloperName: "Developer Name",
  EstimateTime: "Estimate Time",
  StartDate: "Start Date",
  EndDate: "End Date",
  ViewTasksheet: "View Tasksheet",
  EditTasksheet: "Edit Tasksheet",
  AddTasksheet: "Add Tasksheet",
  TasksheetList: "List of Tasksheet",
  TaskDetail: "Task Detail",
  Date: "Date",
  Hour: "Hours",
  Minutes: "Minutes",
  CourseName: "Course Name",
  TaskName: "Task Name",
  EditProject: "Edit Project",
  AddProject: "Add Project",
  ProjectDescription: "Project Description",
  Duration: "Duration",
  TechnologyName: "Technology's Name",
  Project: "Project",
  AddTimesheet: "Add Timesheet",
  AddProject: "Add Project",
  Description: "Description",
  TakenTime: "Taken Time",
  TaskStatus: "Task Status",
  TotalDeveloper: "Total Developer",
  DurationMonth: "Duration(Months)",
  Project: "Project",
  ListOfTimesheet: "List Of Timesheet",
  Task: "Task",
  DailyStatus: "Daily Status",
  RemainingTime: "Remaining Time",
  Reason: "Reason",
  ReviewStatus: "Review Status",
  EditTimesheet: "Edit Timesheet",
  TraineeOption: { value: "trainee", label: "Trainee" },
};
